import { TREQUEST_TNA_BOARD_LISTING, TRESPONSE_TNA_BOARD_LISTING } from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TTnaBoardActionType } from './tna-board.models';

export class GetTnaBoardList implements Action {
  readonly type = TTnaBoardActionType.GetTnaBoardList;
  constructor(public payload: TREQUEST_TNA_BOARD_LISTING) {}
}
export class GetTnaBoardListSuccess implements Action {
  readonly type = TTnaBoardActionType.GetTnaBoardListSucess;
  constructor(public payload: TRESPONSE_TNA_BOARD_LISTING) {}
}

export class GetTnaBoardListFailure implements Action {
  readonly type = TTnaBoardActionType.GetTnaBoardListFaliure;
  constructor() {}
}

export type TTnaBoardActions = GetTnaBoardList | GetTnaBoardListSuccess | GetTnaBoardListFailure;
